export const execed = {
  lse: {
    pre: {
      sourceKey: "src_2gYLRgHjFpYNtzQNURsiKeoBaZH",
      writeKey: "wk_2gYLRd7jRmu6Zg2mk6I4keLarRp",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    ppa: {
      sourceKey: "src_2gYLLpyxRMPrp3nCPDmDpi7GbCa",
      writeKey: "wk_2gYLLlYwbsQoX7K774aJjkwJLYT",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    ref: {
      sourceKey: "src_2gYLJ3DYPHKLV0QPFKm5ruAFpfX",
      writeKey: "wk_2gYLJ2XEoaUx4QhvpEOPuzxXQ7p",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    dam: {
      sourceKey: "src_2gYLG5vlQw2UqxCEqLGPDG1Fb8O",
      writeKey: "wk_2gYLG6YUhbXoHhRWdX8fJdKPQZ7",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    etai: {
      sourceKey: "src_2hQ1oHYwnVsu6HcN2lTm5brusHi",
      writeKey: "wk_2hQ1oHkgfsH0RZcsGj3CiPvctRO",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    lpg: {
      sourceKey: "src_2vUx6Jj9dD20jZ6mixSZ3Ejnllj",
      writeKey: "wk_2vUx6JWijSn07ALYNb7eq2czKT0",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    epp: {
      sourceKey: "src_2xVXZgdDPEdbcosYgnOUoToCG98",
      writeKey: "wk_2xVXZg7I2esVqfpRhN8HXIaynoU",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    pcs: {
      sourceKey: "src_2xVXjuv1YdYIuNOjTzXQZBamvgs",
      writeKey: "wk_2xVXjsb6sQCAGlGNzjbXCnhciQq",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    lcpamn: {
      sourceKey: "src_2vu96yBfWdTmy95oIgeepeNpxrJ",
      writeKey: "wk_2vu970r8eUAs8DA8Bh6nvOUXBhE",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
  },
  oxf: {
    lsc: {
      sourceKey: "src_2gYLDG9sevHBv4SEoJYqJcrnRcs",
      writeKey: "wk_2gYLDG4IuAmtFX1wDoUtQRs5tw1",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
    osleps: {
      sourceKey: "src_2rzg0USgXzrnTS5SY7v8YRkNbYa",
      writeKey: "wk_2rzg0ThgeseDtcWnvWWEdMIzI4w",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
    oaieps: {
      sourceKey: "src_2xVY6PJgDkKUQ0rzbXQidtoaORt",
      writeKey: "wk_2xVY6OSzKbkWw5WyHg8mk7ofPk0",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
    sta: {
      sourceKey: "src_2u8hMSNxpV4cARHYDWnniKFJIgZ",
      writeKey: "wk_2u8hMXo9wVnkhDkJ7VpLCrf1dcx",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
    aim: {
      sourceKey: "src_2rzgC9DQtDr182TMA8Xtp7oxhzk",
      writeKey: "wk_2rzgC3ypDMWVzWQdV37xjIqlp1y",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
  },
  mit: {
    ai: {
      sourceKey: "src_2f0dxW6l86JNhhUH1rPzQFW2obA",
      writeKey: "wk_2f0dxWg9p66P0Rlfo7bgCm3SjcR",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    ahc: {
      sourceKey: "src_2hQ1MXHXxy5ryjKSebiV3Gj7khh",
      writeKey: "wk_2hQ1MXcgOTb720PcMvAERxCm3MB",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    aph: {
      sourceKey: "src_2hQ1rluK4SHODOoSCk860qlbNu3",
      writeKey: "wk_2hQ1rlXPA2sxk5OiZBYVnsUvJap",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    nur: {
      sourceKey: "src_2mLKt3EwjOOzqAnytmhOX3NyTNN",
      writeKey: "wk_2mLKt2m57wZ3rIxNzmiQQ0Unmvq",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    ptd: {
      sourceKey: "src_2rzg4NklDIJckcM931X9Arq1P4k",
      writeKey: "wk_2rzg4SL7XuZ0wyLljFCUfSU6c7Q",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    blc: {
      sourceKey: "src_2vs7gIOfCVX8KiUwHDA9fFvzEg6",
      writeKey: "wk_2vs7gNdlHSnlv6oMqWL1T3XDOat",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    bpd: {
      sourceKey: "src_2vu8vpZ5MwzCQ28gok3LO0u1nyP",
      writeKey: "wk_2vu8votFAOlR2LqBLIHoyUGph9V",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
  },
  camb: {
    bsm: {
      sourceKey: "src_2hQ1IlNROoU6RNIrYnXw5vZTUJy",
      writeKey: "wk_2hQ1Ip4YhPINXjHPrMkZOqm7uI4",
      oneTrust: "01922070-dde6-7a02-9c55-732e94bd6dbe",
    },
    clc: {
      sourceKey: "src_2mKzd2LeyWFdqKHIKsj2TFW8G1Y",
      writeKey: "wk_2mKzd937YkTHMFRHhD09DMK08J5",
      oneTrust: "01922070-dde6-7a02-9c55-732e94bd6dbe",
    },
    inf: {
      sourceKey: "src_2rzg7wVdnh1IMCvaVonzPB5Pisv",
      writeKey: "wk_2rzg7yErDMoyQVm0GqvLfnKFOJQ",
      oneTrust: "01922070-dde6-7a02-9c55-732e94bd6dbe",
    },
    hil: {
      sourceKey: "src_2mKzN3hphFPnVxa9KNPdR8PfjoV",
      writeKey: "wk_2mKzMz53FwdcvLOL7r4AlaWJJmG",
      oneTrust: "01922070-dde6-7a02-9c55-732e94bd6dbe",
    },
    suf: {
      sourceKey: "src_2mKyzcU7rAYNsy9hIMwhracQ4kl",
      writeKey: "wk_2mKyzbx1u6EP738fnXhCOGICd6Y",
      oneTrust: "01922070-dde6-7a02-9c55-732e94bd6dbe",
    },
  },
  harv: {
    bok: {
      sourceKey: "src_2mL09Yua8DWnPHnqoQsYydOyjiQ",
      writeKey: "wk_2mL09UKgmInGGDp0Q24ycvj3OhQ",
      oneTrust: "019301ec-e71b-73bb-b18c-c4aa76a036fc",
    },
    cyb: {
      sourceKey: "src_2mL0JCaAbcFKlqTY7ChlubclKs3",
      writeKey: "wk_2mL0JE6Bj6oSVlDG34Fecs0xDwW",
      oneTrust: "019301ec-e71b-73bb-b18c-c4aa76a036fc",
    },
    fih: {
      sourceKey: "src_2mL0PgBEOeCew382FEPZKM9mABH",
      writeKey: "wk_2mL0PgMFJ5LD32rtpYOo3DhclEo",
      oneTrust: "019301ec-e71b-73bb-b18c-c4aa76a036fc",
    },
  },
  stan: {
    nut: {
      sourceKey: "src_2mLLP6bcov7xRyNvBENZHeu2dWA",
      writeKey: "wk_2mLLP6oMNJtBHXWA3ySJm9CXNbW",
      oneTrust: "019363fa-60c6-721b-8f28-f84a8cc05387",
    },
  },
  uct: {
    da: {
      sourceKey: "src_2rs0AvvDeBfV7CPQj49v1HegFmO",
      writeKey: "wk_2rs0ArsqeJTdAIKP6xBxWqcaJww",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    apm: {
      sourceKey: "src_2vu9BMQk3bcVqxk9WiIxpn2EI7E",
      writeKey: "wk_2vu9BSrb1SL83tYuVCazRfwI8MD",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    pm: {
      sourceKey: "src_2vu9G3XXMEr8AgP06kLTptX41Y2",
      writeKey: "wk_2vu9G25nxyAtEVlpE6WxZGkr92A",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    pdi: {
      sourceKey: "src_2vu9eftSS8nDzWzDayQVw9NxEvV",
      writeKey: "wk_2vu9egRrLSsRXRtsq7kli5HJPp5",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    con: {
      sourceKey: "src_2vu9LxCzjDK2yZEJn65fX4v79Fu",
      writeKey: "wk_2vu9LzOYxRPUJhBNv1aCtw4tZca",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    dm: {
      sourceKey: "src_2vu9kAooiN5UtXP4CyMmWC3Xv9i",
      writeKey: "wk_2vu9kFXQbLVxLoqOrPB1o9VFwOH",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    om: {
      sourceKey: "src_2vu9aqZ23jNwholQ0llKm5sRGQF",
      writeKey: "wk_2vu9aqVslOS1KIwNHZ5ZoXiMF1h",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    cp: {
      sourceKey: "src_2vu9Q0i3IkDifkvJfJI84GHW5Wx",
      writeKey: "wk_2vu9PwweeznOaZS3cy4g25bkgaW",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    bsa: {
      sourceKey: "src_30EOQTxaZQ8RP5h6fFUpTomVt6G",
      writeKey: "wk_30EOQTqrz2AA88BSSHLfdwPNlSl",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    par: {
      sourceKey: "src_30EOR7abcUtJwfJXxM8uZDe2y8R",
      writeKey: "wk_30EORAFFYqXyOMvRcZYNg7kRDR6",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    ivm: {
      sourceKey: "src_30EORmyRJqDJ7vk2ts6IB0JSgWx",
      writeKey: "wk_30EORl7k7sgubZiDWaxFk9i5n6S",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    hr: {
      sourceKey: "src_2mLMmjLXd9tveR2nrX5tiE4wuwm",
      writeKey: "wk_2mLMmkXXnAuKtW3lmpZw9uztOlB",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    tdm: {
      sourceKey: "src_2vu9WhB7UnqI1XE1AqjM6kElEct",
      writeKey: "wk_2vu9WepBqPw9nZOrAX5rKxYp0zk",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    ohs: {
      sourceKey: "src_30EOChAdVrbo09UHsihhdLxHTgP",
      writeKey: "wk_30EOCeTL4wqkeMdQJ2F2Pch0MMQ",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    bk: {
      sourceKey: "src_30EOPAuMmEvcBvFqdyi2LllgvWJ",
      writeKey: "wk_30EOP6yZlRempiB4FqXQQOwD8BH",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    scm: {
      sourceKey: "src_30EOPmGtDD4yCJy8RIbmCZJ8qWh",
      writeKey: "wk_30EOPoVfOsr2qu3UxdbHg0eP38E",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
  },
  utor: {
    hal: {
      sourceKey: "src_2vu9ytEKcTuEJ1jtlX7J5XFEuEF",
      writeKey: "wk_2vu9ysAPqlVB09ABTrOzZAhiLen",
      oneTrust: "0196a779-23cc-7b1b-bf88-ebde9e530b84",
    },
    wol: {
      sourceKey: "src_2vu9vMPa0YdnpofBeTWJk6clylw",
      writeKey: "wk_2vu9vQNyHkMIgklv7zWxoElmxzx",
      oneTrust: "0196a779-23cc-7b1b-bf88-ebde9e530b84",
    },
  },
  yale: {
    wlp: {
      sourceKey: "src_2mLOfgTpr3rrbxOJ68O4fajD3a7",
      writeKey: "wk_2mLOfkdPeeknE0nh9jTv5WFt5Iv",
      oneTrust: "01936400-e0fe-73b3-9ec4-500afb3b7be2",
    },
  },
  econ: {
    bsw: {
      sourceKey: "src_2mL043xcw4gBldbHy1IKv4qJVxA",
      writeKey: "wk_2mL0434dpR026pFLNHevFDpPhJc",
      oneTrust: "019523fa-3288-7b96-b7d7-fc47aefe87ab",
    },
  },
};
